var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRichmond(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    width: 320,
    height: 90,
    viewBox: "0 0 340 90",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 259.762 V 126.445 H 0 Z",
    id: "path16"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,168.59333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "translate(37.7583,70.9688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 17.189,4.573 28.588,7.165 26.945,6.122 57.923,12.839 86.135,14.824 28.903,2.01 53.007,-1.026 53.007,-1.026 l -41.668,11.439 c 0,0 -23.116,0.872 -53.696,-7.206 C 47.751,18.692 0,0 0,0",
    style: {
      fill: "#00a295",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(216.5771,86.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 37.747,-3.16 32.262,-3.706 32.262,-3.706 L 20.26,-19.098 c 0,0 -3.948,3.127 -20.637,3.947 -63.476,3.123 -204.982,-9.938 -204.982,-9.938 0,0 107.069,33.324 205.359,25.089",
    style: {
      fill: "#1b3f67",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g36",
    transform: "translate(77.6943,89.5156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,0 9.029,5.298 22.012,9.331 12.979,4.016 17.009,4.564 17.009,4.564 0,0 -15.668,5.745 -16.598,5.252 C 21.489,18.644 0,0 0,0",
    style: {
      fill: "#f59c2b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(0,0.1201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 259.763",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeWidth: 0.241,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "0.966, 0.966",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g44",
    transform: "translate(0,126.3242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 259.763",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeWidth: 0.241,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "0.966, 0.966",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRichmond);
export default __webpack_public_path__ + "static/media/richmond.ecac082305e66f20df1db1f31cb8f926.svg";
export { ForwardRef as ReactComponent };